import { Component, DestroyRef, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Store } from '@ngxs/store';
import { EMPTY, catchError, switchMap } from 'rxjs';
import { LoadQuestionBank } from './home/state/question.actions';
import { FooterComponent } from './static/components/footer/footer.component';
import { HeaderComponent } from './static/components/header/header.component';
import { LoadLanguages, SetPreviouslySelectedLanguage } from './static/states/language/language.actions';

@Component({
    selector: 'shig-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, RouterOutlet, FooterComponent, MatSnackBarModule]
})
export class AppComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly store = inject(Store);
    private readonly destroyRef = inject(DestroyRef);
    private readonly snackBar = inject(MatSnackBar);

    ngOnInit(): void {
        this.routeToRedirect();
        this.initiateQuestionBank();
        this.initiateLanguages();
    }

    private routeToRedirect(): void {
        const url = window.localStorage.getItem('redirectUrl');
        if (url) {
            void this.router.navigateByUrl(url);
            window.localStorage.removeItem('redirectUrl');
        }
    }

    private initiateLanguages(): void {
        this.store
            .dispatch(new LoadLanguages())
            .pipe(
                switchMap(() => this.store.dispatch(new SetPreviouslySelectedLanguage())),
                catchError(error => this.handleInitError('Failed to initialize languages.', error)),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }

    private initiateQuestionBank(): void {
        this.store
            .dispatch(new LoadQuestionBank())
            .pipe(
                catchError(error => this.handleInitError('Failed to load question bank.', error)),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }

    private handleInitError(message: string, error: unknown) {
        console.error(message, error);
        this.snackBar.open(message, 'Close', { duration: 4000 });
        return EMPTY;
    }
}
